module.exports = __webpack_public_path__ + "static/documents-f3c9da9af74187fb99756735e32c9a5f.png";